/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Used for downgrading collections used in Cloud Module
 * @module CloudServicesModule
 */

import { Injector } from '@angular/core';

import {
    SEGroupCollection,
    SE_GROUP_COLLECTION_TOKEN,
} from 'ajs/modules/service-engine-group';

import {
    CLOUD_COLLECTION_TOKEN,
} from 'ajs/modules/cloud/cloud.tokens';

import { LicenseBasedFeaturesService } from 'ajs/modules/core/services';
import { LICENSE_BASED_FEATURES_SERVICE_TOKEN } from 'ajs/modules/core/core.tokens';
import { RoleCollection } from 'ajs/modules/accounts/factories/role/role.collection.factory';
import { ROLE_COLLECTION_TOKEN } from 'ajs/modules/accounts/accounts.tokens';

import {
    CloudCollection,
    TCloudCollection,
} from 'ajs/modules/cloud/factories/cloud.collection.factory';

const $injector = '$injector';

export const seGroupCollectionProvider = {
    deps: [$injector],
    provide: SEGroupCollection,
    useFactory(injector: Injector): typeof SEGroupCollection {
        return injector.get(SE_GROUP_COLLECTION_TOKEN);
    },
};

export const licenseBasedFeaturesServiceProvider = {
    deps: [$injector],
    provide: LicenseBasedFeaturesService,
    useFactory(injector: Injector): LicenseBasedFeaturesService {
        return injector.get(LICENSE_BASED_FEATURES_SERVICE_TOKEN);
    },
};

export const roleCollectionProvider = {
    deps: [$injector],
    provide: RoleCollection,
    useFactory(injector: Injector): typeof RoleCollection {
        return injector.get(ROLE_COLLECTION_TOKEN);
    },
};

export const cloudCollectionProvider = {
    deps: [$injector],
    provide: CloudCollection,
    useFactory(injector: Injector): TCloudCollection {
        return injector.get(CLOUD_COLLECTION_TOKEN);
    },
};
